export const USER_ACTION_TYPES = {
    SIGN_IN_SUCCESS: "user/SIGN_IN_SUCCESS",
    SIGN_IN_FAILED: "user/SIGN_IN_FAILED",
    SIGN_OUT_SUCCESS: "user/SIGN_OUT_SUCCESS",
    SIGN_OUT_FAILED: "user/SIGN_OUT_FAILED",
    SING_UP_SUCCESS: "user/SING_UP_SUCCESS",
    SING_UP_FAILED: "user/SING_UP_FAILED",
    UPDATE_CURRENT_USER: "user/UPDATE_CURRENT_USER",
  };